import { useEffect } from 'react';

const useDisableRightClick = (dependency: boolean) => {
  // prevent right click
  useEffect(() => {
    const disableRightClick = (e: MouseEvent) => {
      e.preventDefault();
    };

    if (dependency) {
      document.addEventListener('contextmenu', disableRightClick);
    } else {
      document.removeEventListener('contextmenu', disableRightClick);
    }

    return () => {
      document.removeEventListener('contextmenu', disableRightClick);
    };
  }, [dependency]);
};

export default useDisableRightClick;
